import {charcoal} from '../sass/base/_exports.sass';

export const SearchLineIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.0414 22.156L29.752 27.8653L27.8654 29.752L22.156 24.0413C20.0317 25.7443 17.3894 26.6705 14.6667 26.6667C8.04269 26.6667 2.66669 21.2907 2.66669 14.6667C2.66669 8.04267 8.04269 2.66667 14.6667 2.66667C21.2907 2.66667 26.6667 8.04267 26.6667 14.6667C26.6706 17.3893 25.7443 20.0317 24.0414 22.156ZM21.3667 21.1667C23.0588 19.4265 24.0038 17.0939 24 14.6667C24 9.50934 19.8227 5.33334 14.6667 5.33334C9.50935 5.33334 5.33335 9.50934 5.33335 14.6667C5.33335 19.8227 9.50935 24 14.6667 24C17.0939 24.0038 19.4265 23.0588 21.1667 21.3667L21.3667 21.1667Z"
        fill={color}
      />
    </svg>
  );
};
